var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKpiInactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3034 4.69678C16.71 6.1033 17.5002 8.01097 17.5002 10.0001C17.5002 11.9893 16.71 13.8969 15.3034 15.3034M15.3034 15.3034L12.9459 12.9459M15.3034 15.3034L10.0001 10.0001M10.0001 10.0001L7.05344 12.9468M10.0001 10.0001L12.9468 7.05344M10.0001 10.0001L4.69678 4.69678",
    stroke: "#EF4444",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiInactiveIcon);
export default __webpack_public_path__ + "static/media/kpi_inactive_icon.e755c2dcb4bbe32c158d01c733f38a01.svg";
export { ForwardRef as ReactComponent };